export const getStudioInfoForGrade = (gradeStr) => {
  if (!gradeStr) return { type: "block", label: "Practido Blocks" };
  const numMatch = gradeStr.toString().match(/\d+/);
  const gradeNum = numMatch ? parseInt(numMatch[0], 10) : 5;
  if (gradeNum >= 1 && gradeNum <= 3) {
    return { type: "junior", label: "Junior Blocks" };
  }
  if (gradeNum >= 4 && gradeNum <= 8) {
    return { type: "block", label: "Practido Blocks" };
  }
  if (gradeNum >= 9) {
    return { type: "python", label: "Practido Code" };
  }
  return { type: "block", label: "Practido Blocks" };
};

export const formatGradeLabel = (gradeStr) => {
  if (!gradeStr) return "Class N/A";
  const str = gradeStr.toString().trim();
  if (str.toLowerCase().startsWith("class")) return str;
  if (str.toLowerCase().startsWith("grade")) return `Class ${str.substring(5).trim()}`;
  return `Class ${str}`;
};
